




























































































import Vue from "vue";
import axios from "axios";
import SelectBox from "@/components/util/SelectBox.vue";
import VariableInput, { VariableInputProps } from "@/components/util/VariableInput.vue";
import CorpInformationForm from "@/views/corporate/forms/CorpInformationForm.vue";
import {
  corporateNameRegExp,
  corporateNameLengthLimit,
  corporateNameConstraintErrorMessage,
  corporateNameKanaRegExp,
  corporateNameKanaLengthLimit,
  corporateNameKanaConstraintErrorMessage,
  corporateRepresentativeRegExp,
  corporateRepresentativeLengthLimit,
  corporateRepresentativeConstraintErrorMessage,
  corporateRepresentativeKanaRegExp,
  corporateRepresentativeKanaLengthLimit,
  corporateRepresentativeKanaConstraintErrorMessage,
  divisionNameRegExp,
  divisionNameLengthLimit,
  divisionNameConstraintErrorMessage,
  mailAddressRegExp,
  mailAddressLengthLimit,
  mailAddressConstraintErrorMessage,
  authPhoneNumberRegExp,
  authPhoneNumberLengthLimit,
  authPhoneNumberConstraintErrorMessage,
  faxRegExp,
  faxLengthLimit,
  faxConstraintErrorMessage,
} from "@/views/corporate/forms/constraint";
import CorporateSideTabs from "@/parts/corporate/CorporateSideTabs.vue";
import { UserProfile } from '@/api/dto/UserProfile';

import {
  updateUserProfile,
  getUserProfile,
} from "@/api/UserProfile";
import { IconUpdateFlag, GetUserProfileResponse, CreatePaymentInformationRequest } from "@/api/dto/UserProfile";
import { GetCorpResponse, CreateCorpInfoRequest } from "@/api/dto/CorpInfo";
import { getCorpInfo, updateCorpInfo, updateCorpIcon } from "@/api/CorpInfo";
import { ErrorResponse } from "@/api/dto/Error";

import { defaultIconUrl } from "@/properties";

interface Data {
  defaultIconUrl: string;
  profileImage: File | null;
  profileUpdateFlag: IconUpdateFlag;
  profileData: GetUserProfileResponse;
  readData: boolean;
  corpInfoForm: GetCorpResponse;
  corpInfo: CreateCorpInfoRequest;
  signupInputs: {
    corporateName: {
      name: string;
      type: string;
      placeholder: string;
      class: string;
      required: boolean;
      constraint: string;
      error: string;
    };
    corporateNameKana: {
      name: string;
      type: string;
      placeholder: string;
      class: string;
      required: boolean;
      constraint: string;
      error: string;
    };
    divisionName: {
      name: string;
      type: string;
      placeholder: string;
      class: string;
      required: boolean;
      constraint: string;
      error: string;
    };
    corporateRepresentative: {
      name: string;
      type: string;
      placeholder: string;
      class: string;
      required: boolean;
      constraint: string;
      error: string;
    };
    corporateRepresentativeKana: {
      name: string;
      type: string;
      placeholder: string;
      class: string;
      required: boolean;
      constraint: string;
      error: string;
    };
    contactMailAddress: {
      name: string;
      type: string;
      placeholder: string;
      class: string;
      required: boolean;
      constraint: string;
      error: string;
    };
    phoneNumber: {
      name: string;
      type: string;
      placeholder: string;
      class: string;
      required: boolean;
      constraint: string;
      error: string;
    };
    fax: {
      name: string;
      type: string;
      placeholder: string;
      class: string;
      required: boolean;
      constraint: string;
      error: string;
    };
  };
  accountType: string;
}

export default Vue.extend({
  name: "CorpInfo",
  components: {
    SelectBox,
    VariableInput,
    CorpInformationForm,
    CorporateSideTabs,
  },
  props: {
    modeName: String,
    confirm: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    this.$store.commit("setMode", { mode: "corporate" });
    return {
      defaultIconUrl,
      profileImage: null,
      profileUpdateFlag: "0",
      profileData: {} as GetUserProfileResponse,
      readData: false,
      corpInfo: {} as CreateCorpInfoRequest,
      corpInfoForm: {} as GetCorpResponse,
      signupInputs: {
        corporateName: {
          name: "法人名",
          type: "text",
          placeholder: "株式会社レビューマーケッツ",
          class: "input-width-full",
          required: true,
          constraint: corporateNameConstraintErrorMessage,
          error: "",
        },
        corporateNameKana: {
          name: "法人名カナ",
          type: "text",
          placeholder: "カブシキガイシャレビューマーケッツ",
          class: "input-width-full",
          required: true,
          constraint: corporateNameKanaConstraintErrorMessage,
          error: "",
        },
        divisionName: {
          name: "部署名",
          type: "text",
          placeholder: "システム開発事業部",
          class: "input-width-full",
          required: false,
          constraint: divisionNameConstraintErrorMessage,
          error: "",
        },
        corporateRepresentative: {
          name: "担当者名",
          type: "text",
          placeholder: "山田 太郎",
          class: "input-width-full",
          required: true,
          constraint: corporateRepresentativeConstraintErrorMessage,
          error: "",
        },
        corporateRepresentativeKana: {
          name: "担当者名カナ",
          type: "text",
          placeholder: "ヤマダ タロウ",
          class: "input-width-full",
          required: true,
          constraint: corporateRepresentativeKanaConstraintErrorMessage,
          error: "",
        },
        contactMailAddress: {
          name: "連絡先メール",
          type: "text",
          placeholder: "revma@example.com",
          class: "input-width-full",
          required: true,
          constraint:  mailAddressConstraintErrorMessage,
          error: "",
        },
        phoneNumber: {
          name: "電話番号",
          type: "text",
          placeholder: "0123456789",
          class: "input-width-half",
          required: true,
          constraint: authPhoneNumberConstraintErrorMessage,
          error: "",
        },
        fax: {
          name: "FAX",
          type: "text",
          placeholder: "0123456789",
          class: "input-width-half",
          required: false,
          constraint: faxConstraintErrorMessage,
          error: "",
        },
      },
      accountType: "1",
    };
  },
  async beforeRouteEnter(to, from, next) {
    const userProfRes = await getUserProfile();
    const corpInfoRes = await getCorpInfo();

    next((vm) => {
      vm.$store.dispatch("updateCorpInfoForm", {
        form: {
          ...corpInfoRes,
        },
      });
      (vm.$data as Data).profileData = userProfRes;
      (vm.$data as Data).corpInfoForm = corpInfoRes;
    });
  },
  watch: {
    "corpInfoForm.corporateName"(corporateName: string) {
      this.beforeWatch();
      if (this.confirm) return;
      this.signupInputs["corporateName"].error =
        corporateName.length <= corporateNameLengthLimit && corporateNameRegExp.test(corporateName)
          ? ""
          : corporateNameConstraintErrorMessage;
      this.afterWatch();
    },
    "corpInfoForm.corporateNameKana"(corporateNameKana: string) {
      this.beforeWatch();
      if (this.confirm) return;
      this.signupInputs["corporateNameKana"].error =
        corporateNameKana.length <= corporateNameKanaLengthLimit && corporateNameKanaRegExp.test(corporateNameKana)
          ? ""
          : corporateNameKanaConstraintErrorMessage;
      this.afterWatch();
    },
    "corpInfoForm.divisionName"(divisionName: string) {
      this.beforeWatch();
      if (this.confirm) return;
      this.signupInputs["divisionName"].error =
        divisionName.length <= divisionNameLengthLimit && divisionNameRegExp.test(divisionName)
          ? ""
          : divisionNameConstraintErrorMessage;
      this.afterWatch();
    },
    "corpInfoForm.corporateRepresentative"(corporateRepresentative: string) {
      this.beforeWatch();
      if (this.confirm) return;
      this.signupInputs["corporateRepresentative"].error =
        corporateRepresentative.length <= corporateRepresentativeLengthLimit && corporateRepresentativeRegExp.test(corporateRepresentative)
          ? ""
          : corporateRepresentativeConstraintErrorMessage;
      this.afterWatch();
    },
    "corpInfoForm.corporateRepresentativeKana"(corporateRepresentativeKana: string) {
      this.beforeWatch();
      if (this.confirm) return;
      this.signupInputs["corporateRepresentativeKana"].error =
        corporateRepresentativeKana.length <= corporateRepresentativeKanaLengthLimit && corporateRepresentativeKanaRegExp.test(corporateRepresentativeKana)
          ? ""
          : corporateRepresentativeKanaConstraintErrorMessage;
      this.afterWatch();
    },
    "corpInfoForm.contactMailAddress"(contactMailAddress: string) {
      this.beforeWatch();
      if (this.confirm) return;
      this.signupInputs["contactMailAddress"].error =
        contactMailAddress.length <= mailAddressLengthLimit && mailAddressRegExp.test(contactMailAddress)
          ? ""
          : mailAddressConstraintErrorMessage;
      this.afterWatch();
    },
    "corpInfoForm.phoneNumber"(phoneNumber: string) {
      this.beforeWatch();
      if (this.confirm) return;
      this.signupInputs["phoneNumber"].error =
        phoneNumber.length <= authPhoneNumberLengthLimit && authPhoneNumberRegExp.test(phoneNumber)
          ? ""
          : authPhoneNumberConstraintErrorMessage;
      this.afterWatch();
    },
    "corpInfoForm.fax"(fax: string) {
      this.beforeWatch();
      if (this.confirm) return;
      this.signupInputs["fax"].error =
        fax.length === 0 || (fax.length <= faxLengthLimit && faxRegExp.test(fax)) ? "" : faxConstraintErrorMessage;
      this.afterWatch();
    },
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
    mode(): string {
      return this.$store.state.mode;
    },
    iconUrl(): string {
      let user = this.$store.getters.userProfile as UserProfile;
      return user.corporationsData.iconUrl;
    },
    /**
     * どれかエラーがあればdisabled
     */
    submitDisabled(): boolean {
      return (this.signupInputs.corporateName.error.length > 0 ||
        this.signupInputs.corporateNameKana.error.length > 0 ||
        this.signupInputs.divisionName.error.length > 0 ||
        this.signupInputs.corporateRepresentative.error.length > 0 ||
        this.signupInputs.corporateRepresentativeKana.error.length > 0 ||
        this.signupInputs.contactMailAddress.error.length > 0 ||
        this.signupInputs.phoneNumber.error.length > 0 ||
        this.signupInputs.fax.error.length > 0)
    },
  },
  methods: {
    showToast(msg: string) {
      this.$emit("toast", msg);
    },
    errorToast(msg: string) {
      this.$emit("errorToast", msg);
    },
    changeMode(key: string) {
      this.$store.commit("setMode", { mode: key });
    },
    async getUserProfile() {
      try {
        const res = await getUserProfile();
        this.profileData = {
          ...res,
          // 表示名が空の場合、ユーザーIDを表示する
          nickname: res.nickname ? res.nickname : this.$store.state.user.userId,
        };
      } catch (e) {
        console.log(e);
      }
    },
    uploadFile(e: Event) {
      e.preventDefault();
      if (!(e?.target instanceof HTMLInputElement)) {
        return;
      }
      const file = e.target.files?.[0];
      if (!file) {
        return;
      }
      this.profileImage = file;
      this.profileUpdateFlag = "1";
      this.profileData.iconUrl = URL.createObjectURL(file);

      this.updateCorpIcon();
    },
    deleteFile() {
      this.profileImage = null;
      this.profileUpdateFlag = "2";
      this.profileData.iconUrl = "";
      (this.$refs.iconUploader as HTMLInputElement).value = "";

      this.updateCorpIcon();
    },
    async updateCorpIcon() {
      try {
        const res = await updateCorpIcon({
          icon: this.profileImage,
          iconUpdateFlag: this.profileUpdateFlag
        })
        this.profileImage = null;
        this.profileUpdateFlag = "0";
        this.$store.dispatch("userUpdate");
        this.$emit("toast", "アイコンを更新しました");
      } catch (e) {
        console.log(e);
        this.$emit("errorToast", "アイコンの更新に失敗しました。時間おいて再度お試しください");
      }
    },
    async updateCorpInfo() {
      try {
        await updateCorpInfo(this.corpInfoForm);
        this.$emit("toast", "法人情報を更新しました");
      } catch (e) {
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          if (resError.message == null) {
            this.$emit("errorToast", "法人情報の更新に失敗しました。しばらく経ってからやり直してください。");
          } else {
            this.$emit("errorToast", resError.message);
          }
        }
      }
    },
    beforeWatch() {
      this.$emit("beforeWatch", this);
    },
    afterWatch() {
      this.submitDisabled;
      this.$emit("afterWatch", this);
    },
    /**
     * パスワード設定画面に遷移する
     */
    toChangePassword() {
      this.$router.push({ name: "CorpPasswordChange" });
    },
    /**
     * メールアドレス設定画面に遷移する
     */
    toChangeMailAddress() {
      this.$router.push({ name: "CorpMailAddressChange" });
    },
  },
});
